import { MdSettings } from 'react-icons/md';
import {
  MBox,
  MCustomIconButton,
  MFlex,
  MText,
} from '../../../../components/Monetize';
import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';
import { OneTimeInvoiceBasicContacts } from './OneTimeInvoiceBasicContacts';
import { OneTimeInvoiceBasicDetails } from './OneTimeInvoiceBasicDetails';
import { OneTimeInvoiceBasicInvoice } from './OneTimeInvoiceBasicInvoice';
import { useOneTimeInvoice } from './oneTimeInvoiceContext';

const ColumnDivider = () => (
  <MBox mx="6" display={['hidden', 'hidden', 'visible']}>
    <MBox w="1px" background="tGray.support" height="100%" />
  </MBox>
);

const ColumnHeader = ({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) => (
  <MFlex
    borderBottomWidth="1px"
    borderColor="tGray.support"
    alignItems="center"
    justifyContent="space-between"
  >
    <MText my="2" fontWeight="600" fontSize="md">
      {title}
    </MText>
    {children}
  </MFlex>
);

/**
 * Invoice setup card — the three column header that mirrors the quote setup
 * section.
 */
export const OneTimeInvoiceBasic = ({ value }: { value?: string }) => {
  const { openContactsDrawer } = useOneTimeInvoice();

  return (
    <QuoteBodyAccordion title="Invoice Setup" value={value}>
      <MFlex flexDir={['column', 'column', 'column', 'row']}>
        <MBox flex="1">
          <ColumnHeader title="Invoice" />
          <OneTimeInvoiceBasicInvoice />
        </MBox>

        <ColumnDivider />

        <MBox flex="1">
          <ColumnHeader title="Contacts">
            <MCustomIconButton
              btnSize={4}
              minW={6}
              minH={6}
              variant="icon"
              icon={MdSettings}
              iconColor="tIndigo.base"
              aria-label="Edit contacts"
              data-testid="contact-drawer-open-btn"
              onClick={openContactsDrawer}
            />
          </ColumnHeader>
          <OneTimeInvoiceBasicContacts />
        </MBox>

        <ColumnDivider />

        <MBox flex="1">
          <ColumnHeader title="Details" />
          <OneTimeInvoiceBasicDetails />
        </MBox>
      </MFlex>
    </QuoteBodyAccordion>
  );
};
